import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'

@inject('localizationStore')

@observer
export default class Unuthorized extends React.Component<any> {
    render() {
        let ls = this.props.localizationStore!

        return (
            <div>
                <h3>{ls.t!('Unuthorized page')}</h3>
                <NavLink to="/login">{ls.t!('LoginBtn')}</NavLink>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/Unauthorized.tsx